import type { ApiClient } from '../../core/api-client.js';
import { ApiError } from '../../core/api-client.js';
import type { Notificacao } from '@pgcustom/shared-types';

/**
 * Adapter do centro de notificações no frontend — `/api/v1/notificacoes/*`
 * (`apps/api/src/server.ts`, Sprint 13, `DECISIONS.md` DEC-032).
 * Self-service: escopado ao próprio usuário autenticado pelo backend,
 * sem parâmetro de destinatário aqui.
 */
export class NotificacoesApi {
  constructor(private readonly api: ApiClient) {}

  /** Devolve `[]` quando o endpoint falha silenciosamente (nunca quebra o sino do header por uma falha transitória). */
  async listar(): Promise<Notificacao[]> {
    try {
      const resposta = await this.api.get<{ notificacoes: Notificacao[] }>('/notificacoes');
      return resposta.notificacoes;
    } catch (erro) {
      if (erro instanceof ApiError) return [];
      throw erro;
    }
  }

  async marcarComoLida(id: string): Promise<void> {
    await this.api.post(`/notificacoes/${id}/lida`);
  }
}
